<script>
import { authComputed } from '@state/helpers'
import { mapGetters } from 'vuex'
import Network from "@plugins/Network";
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: { Network },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    toggleMenu: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      environment: process.env.ENVIRONMENT,
    }
  },
  computed: {
    ...authComputed,
    ...mapGetters({
      session: 'auth/currentSession',
    }),
    getCompanyInfo: function() {
      return this.$store.state.appAuth.companyInfo || null
    },
    isPublicProject() {
      return this.session && this.session.publicProject
    },
  },
  methods: {
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
    toLogOut() {
      this.$router.push({ name: 'logout' })
    },
  },
}
</script>

<template>
  <!-- Topbar Start -->
  <Network v-slot="status">
    <div
      class="navbar-custom"
      :style="[
        getCompanyInfo && getCompanyInfo.primary_color
          ? { 'background-color': status.isOnline === true ? getCompanyInfo.primary_color : 'dimgray' }
          : { 'background-color': status.isOnline === true ? getCompanyInfo.primary_color : 'black'  },
      ]"
    >
      <ul class="list-unstyled topnav-menu float-right mb-0">
        <!-- <li class="d-none d-sm-block">
          <form class="app-search">
            <div class="app-search-box">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search..."
                />
                <div class="input-group-append">
                  <button
                    class="btn"
                    type="submit"
                  >
                    <i class="fe-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </li> -->
        <!-- <li v-if="loggedIn" class="d-inline d-sm-none" right>
            <div class="nav-link mr-0 waves-effect waves-light">
                <b-button 
                  v-b-popover.hover.bottomleft="`${status.isOnline ? 'En línea' : 'Desconectado' }. 
                        ${status.downlink > 4 ? 'Recepción excelente' : status.downlink >= 1.3 ? 'Recepción buena' : 
                        status.downlink >= 0.3 ? 'Recepción aceptable' : status.isOnline ? 'Recepción pobre' : 'Modo offline' }`" 
                        variant="light" pill class="px-2 py-1" >
                  <b-icon-wifi-off v-if="status.downlink < 0.3 || status.isOnline === false" variant="danger" font-scale="2" />
                  <b-icon-wifi v-else-if="status.downlink > 4" variant="success" font-scale="2" />
                  <b-icon-wifi2 v-else-if="status.downlink >= 1.3" variant="success" font-scale="2" />
                  <b-icon-wifi1 v-else-if="status.downlink >= 0.3" variant="warning" font-scale="2" />
                </b-button>
            </div>
        </li> -->
        <div v-if="!isPublicProject">
          <b-nav-item-dropdown
            v-if="loggedIn"
            right
            class="notification-list"
            menu-class="profile-dropdown"
          >
            <template slot="button-content">
              <div class="nav-user mr-0 waves-effect waves-light">
                  <img
                    :src="
                      currentSession.user.user_info &&
                      currentSession.user.user_info.photo
                        ? currentSession.user.user_info.photo
                        : require('@assets/images/users/avatar-clear.png')
                    "
                    alt="user-image"
                    class="rounded-circle"
                    :class="{
                      'border-danger' : status.isOnline === false,
                      'border-success' : status.isOnline === true,

                    }"
                  />
                  <span class="pro-user-name ml-1">
                    {{
                      currentSession.user.first_name
                        ? currentSession.user.first_name.charAt(0).toUpperCase() +
                          currentSession.user.first_name.slice(1)
                        : currentSession.user.username.charAt(0).toUpperCase() +
                          currentSession.user.username.slice(1)
                    }}
                    <i class="mdi mdi-chevron-down"></i>
                  </span>
              </div>
            </template>

            <b-dropdown-item href="/logout">
              <i class="fe-log-out mr-1"></i>
              <span>{{$t('Logout')}}</span>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </div>
        <div v-else>
          <b-button class="my-2" variant="primary" @click="toLogOut"
            >Terminar</b-button
          >
        </div>
      </ul>

      <!-- LOGO -->
      <div class="logo-box">
        <a href="/" class="logo text-center">
          <span class="logo-lg bg-secondary">
            <img
              v-if="getCompanyInfo && getCompanyInfo.light_logo"
              :src="
                getCompanyInfo.light_logo ||
                  require('@assets/images/triduum/triduum-logo-g-w.svg')
              "
              alt=""
              height="55"
            />
            <!-- <span class="logo-lg-text-light">Xeria</span> -->
          </span>
          <span class="logo-sm bg-white">
            <!-- <span class="logo-sm-text-dark">X</span> -->
            <img
              v-if="getCompanyInfo && getCompanyInfo.short_light_logo"
              :src="
                getCompanyInfo.short_light_logo ||
                  require('@assets/images/triduum/triduum-m-w.svg')
              "
              alt=""
              class="m-1"
              height="44"
            />
          </span>
        </a>
      </div>

      <ul v-if="!isPublicProject" class="list-unstyled topnav-menu topnav-menu-left m-0">
        <li>
          <button
            class="button-menu-mobile waves-effect waves-light"
            @click="toggleMenu"
          >
            <i class="fe-menu"></i>
          </button>
        </li>
      </ul>
    </div>
  </Network>
  <!-- end Topbar -->
</template>

<style lang="scss">
@import '@design';
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
}
.rounded-circle {
  &.border-success {
    border: 3px solid lighten($success, 10%);
  }
  &.border-danger {
    border: 3px solid lighten($danger, 10%);
  }
}
</style>
